import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { carTestLabels } from "@/i18n/labels";
import { useLanguage } from "@/context/LanguageContext";
import { cn } from "@/lib/utils";

export type CarTestListSort =
  | "-createdAt"
  | "createdAt"
  | "-updatedAt"
  | "updatedAt";

type CarTestSortSelectProps = {
  value: CarTestListSort;
  onValueChange: (value: CarTestListSort) => void;
  className?: string;
  triggerClassName?: string;
};

export function CarTestSortSelect({
  value,
  onValueChange,
  className,
  triggerClassName,
}: CarTestSortSelectProps) {
  const { language } = useLanguage();
  const ct = carTestLabels(language);
  const f = ct.filters as Record<string, string>;

  return (
    <div className={cn("backdrop-blur min-w-0", className)}>
      <Select value={value} onValueChange={(v) => onValueChange(v as CarTestListSort)}>
        <SelectTrigger
          className={cn(
            "text-sm h-9 min-h-9 w-full min-w-0",
            triggerClassName,
          )}
        >
          <SelectValue placeholder={f.sortBy ?? "Sortera"} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value="-createdAt">
            {f.sortCreatedDesc ?? "Påbörjat (nyast)"}
          </SelectItem>
          <SelectItem value="createdAt">
            {f.sortCreatedAsc ?? "Påbörjat (äldst)"}
          </SelectItem>
          <SelectItem value="-updatedAt">
            {f.sortUpdatedDesc ?? "Uppdaterat (nyast)"}
          </SelectItem>
          <SelectItem value="updatedAt">
            {f.sortUpdatedAsc ?? "Uppdaterat (äldst)"}
          </SelectItem>
        </SelectContent>
      </Select>
    </div>
  );
}
